import $ from 'jquery';

const $successBox = document.querySelector('.success-box');
const $number = $('.success-box__card-number span');

const $body = $('.page__body');
if ($successBox) {
    $(function () {
        $body.on('scroll', triggerIsInViewport);
    });
}

const counter = () => {
    $number.each(function () {
        const This = $(this);
        $({ Count: This.text() }).animate(
            { Count: This.parent().data('count') },
            {
                duration: 700,
                easing: 'swing',
                step: function () {
                    This.text(Math.floor(this.Count));
                },
                complete: function () {
                    This.text(this.Count);
                },
            }
        );
    });
};

const isInViewport = el => {
    const rect = el.getBoundingClientRect();
    if (rect.top >= -50 && rect.bottom <= window.innerHeight + 150) {
        return counter();
    }
    // else {
    //     $number.text('0');
    // }
};

const triggerIsInViewport = () => {
    isInViewport($successBox);
};
